export var defaultProps = {
  imageVisibilityBreakpoint: "medium",
  imagePosition: "right"
};